import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom"; 
import Sidebar from "./Sidebar";
import Header from "./Header";
import useOrderSocket from "../hooks/useOrderSocket";
import OrderAlertModal from "../components/order/OrderAlertModal"; 

import "./layout.css";


export default function MainLayout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [newOrderAlert, setNewOrderAlert] = useState(null);
//   const [newOrderAlert, setNewOrderAlert] = useState({
//     id: "019d775c-ae2a-72db-8fa9-3f00bcffca21",
//     amount: "5000",
//     status: "S01",
//     order_type: { name: "Course Immédiate" },
//     customer: {
//         user: { firstName: "Test", lastName: "User" }
//     }
// });
  const audioRef = useRef(null);
  const navigate = useNavigate();

const stopAlarm = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    setNewOrderAlert(null);
  };
  
  useOrderSocket((payload) => {
    if (payload.action === 'created') {
      if (!audioRef.current) {
        audioRef.current = new Audio("/sounds/automobile-horn.mp3");
      }
      audioRef.current.loop = true; 
      audioRef.current.play().catch(e => console.log("Cliquer sur la page d'abord"));

      setNewOrderAlert(payload.data);
    }
  });

  const handleViewOrder = (order) => {
  stopAlarm();
  navigate(`/rides/${order.id}`); 
};

  return (
    <div className="appShell">
     <OrderAlertModal 
      order={newOrderAlert} 
      onClose={stopAlarm} 
      onView={(order) => {
        stopAlarm(); 
        navigate(`/rides/${order.id}`); 
      }}
    />

      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <div className="appMain">
        <Header onToggleSidebar={() => setSidebarOpen((v) => !v)} />

        <main className="appContent">
          {children}
        </main>
      </div>
    </div>
  );
}